import { notFound } from 'next/navigation';

import type { IAccommodationRoomStatus } from '@/entities/accommodation/types';
import type { IProductOptions } from '@/entities/product/types';
import { utilDateDecrease, utilDateFormat } from '@/lib/date';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

interface IParams extends IProductOptions {
  startDate: Date | null;
  endDate: Date | null;
}

const apiGetAccommodationRoomPriceList = async ({
  idx,
  lng,
  startDate,
  endDate,
}: IParams): Promise<IAccommodationRoomStatus[]> => {
  if (!startDate || !endDate) return [];

  // endDate를 하루 빼기

  const response = await utilFetch(lng)(
    `${NEXT_PUBLIC_API_URL}/api/accommodations/rooms/${idx}/prices?startDate=${utilDateFormat(startDate, 'YYYY-MM-DD')}&endDate=${utilDateFormat(utilDateDecrease({ date: endDate, type: 'day', value: 1 }), 'YYYY-MM-DD')}`,
    {
      method: 'GET',
    },
  );
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  return result.data;
};

export default apiGetAccommodationRoomPriceList;
